module.exports = new __parcel__URL__("incidents-preview-dark.30e9470b.svg").toString();